import { useTranslations } from '@vocab/react';
import { Alert, Text } from 'braid-design-system';
import React from 'react';

import translations from './.vocab';

const CurrentPasswordNotRequired = () => {
  const { t } = useTranslations(translations);
  return (
    <Alert tone="info">
      <Text>{t('Current password is not required for CS')}</Text>
    </Alert>
  );
};

export default CurrentPasswordNotRequired;
